import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from './utils/constants';

export const getThreadVideoSessions = async (
  thread,
  lastEvaluatedKey,
  limit
) => {
  const threadId = thread.isSubthread
    ? 'subthread'
    : thread.threadId || thread.id;
  const apiPath = `chat/${threadId}/get-thread-video-sessions`;

  const body = {
    target: thread.target,
    type: thread.type,
    lastEvaluatedKey,
    limit,
  };
  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return {
    sessions: response.data.sessions,
    lastEvaluatedKey: response.data.lastEvaluatedKey,
  };
};
